/** Converts common YouTube watch/share URLs into an embeddable iframe src. */
export function getYouTubeEmbedUrl(url: string, autoplay: boolean): string | null {
  try {
    const parsed = new URL(url.trim());
    const host = parsed.hostname.replace(/^www\./, '');

    let videoId: string | null = null;
    if (host === 'youtu.be') {
      videoId = parsed.pathname.split('/').filter(Boolean)[0] ?? null;
    } else if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
      if (parsed.pathname.startsWith('/embed/')) {
        videoId = parsed.pathname.split('/')[2] ?? null;
      } else if (parsed.pathname.startsWith('/shorts/')) {
        videoId = parsed.pathname.split('/')[2] ?? null;
      } else {
        videoId = parsed.searchParams.get('v');
      }
    }

    if (!videoId) {
      return null;
    }

    const embed = new URL(`https://www.youtube-nocookie.com/embed/${videoId}`);
    if (autoplay) {
      embed.searchParams.set('autoplay', '1');
      embed.searchParams.set('mute', '1');
    }
    return embed.toString();
  } catch {
    return null;
  }
}
